import { createRouter, createWebHistory } from "vue-router"
import { nextTick } from "vue"
import Boosters from "../views/Boosters.vue"

const maintenanceMode = false

const routes = [
	{
		name: "Accueil",
		path: "/",
		component: () => import("@/views/Home.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Mes Boosters",
		path: "/boosters",
		component: () => import("@/views/Boosters.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Mes Collections",
		path: "/collections",
		component: () => import("@/views/Collections.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Échanges",
		path: "/trades",
		component: () => import("@/views/Trades.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Mes Statistiques",
		path: "/statistics",
		component: () => import("@/views/Statistics.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Statistiques du joueur",
		path: "/statistics/:id",
		component: () => import("@/views/Statistics.vue"),
		meta: {
			needAccount: false,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Mes Succès",
		path: "/achievements",
		component: () => import("@/views/Achievements.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Succès du joueur",
		path: "/achievements/:id",
		component: () => import("@/views/Achievements.vue"),
		meta: {
			needAccount: false,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Boutique",
		path: "/shop",
		component: () => import("@/views/Shop.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Salle des coffres",
		path: "/treasure-room",
		component: () => import("@/views/TreasureRoom.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Codes",
		path: "/codes",
		component: () => import("@/views/Codes.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Classement",
		path: "/leaderboard",
		component: () => import("@/views/Leaderboard.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Config",
		path: "/config",
		component: () => import("@/views/Config.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: ["creator"],
		},
	},
	{
		name: "Logs",
		path: "/logs",
		component: () => import("@/views/Logs.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: ["seller", "moderator"],
		},
	},
	{
		name: "Utilisateurs",
		path: "/users",
		component: () => import("@/views/Users.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: ["seller", "moderator"],
		},
	},
	{
		name: "Générateur de codes",
		path: "/codesGenerator",
		component: () => import("@/views/CodesGenerator.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: ["seller", "moderator"],
		},
	},
	{
		name: "Connexion",
		path: "/login",
		component: () => import("@/views/Login.vue"),
		meta: {
			needAccount: false,
			showNav: false,
			permissions: [],
		},
	},
	{
		name: "Demande d'accès",
		path: "/askAccess",
		component: () => import("@/views/AskAccess.vue"),
		meta: {
			needAccount: false,
			showNav: false,
			permissions: [],
		},
	},
	{
		name: "Casino",
		path: "/casino",
		component: () => import("@/views/Casino.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	{
		name: "Marché Noir",
		path: "/black-market",
		component: () => import("@/views/BlackMarket.vue"),
		meta: {
			needAccount: true,
			showNav: true,
			permissions: [],
		},
	},
	// {
	// 	name: "Hôtel des ventes",
	// 	path: "/auction",
	// 	component: () => import("@/views/Auction.vue"),
	// 	meta: {
	// 		needAccount: true,
	// 		showNav: true,
	// 		permissions: [],
	// 	},
	// },
  {
    name: 'Maintenance',
    path: '/maintenance',
    component: () => import("@/views/Maintenance.vue"),
    meta: {
      needAccount: false,
      showNav: false,
      permissions: []
    }
  },
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
})

router.beforeEach((to, from, next) => {
  if (maintenanceMode && to.path !== '/maintenance') {
    next('/maintenance')
  } else {
    next()
  }
})

router.afterEach((to, from) => {
	nextTick(() => {
		document.title = "21 Booster - " + to.name
	})
})

export default router
